var exports = {
  "i": "xaee3c4fa--1049b3--wrapper",
  "A": "xaee3c4fa--1049b3--item",
};

module.exports = exports;
